import { API } from '@Providers';

interface RemoveRetailPresetDiscountPayload {
  code: string;
}

export default async function removeRetailPresetDiscount(payload: RemoveRetailPresetDiscountPayload) {
  const endpoint = '/api/shelter/cart/remove-retail-preset-discount/';

  return API({ endpoint, method: 'delete', payload });
}
